import {
  ApiGetRequest,
  // ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostRequest,
} from '../../api';
import { showNotif } from '../notification';
// import { _ } from 'vue-underscore';

export const state = {
  data: {
    title: 'Customer Price',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/conf',
      },
      {
        text: 'Users',
        href: '/adm/conf/principle-price',
        active: true,
      },
    ],
    tab_active: 0,
    tab_name: {
      tab_0: 'payment_type',
      tab_1: 'storage',
      tab_2: 'document',
      tab_3: 'lift_off',
      tab_4: 'lift_on',
      tab_5: 'cleaning',
      tab_6: 'seal',
      tab_7: 'cancelation',
      tab_8: 'otherfee',
    },
    payment_type: [],
    fees_storage: ['Storage'],
    fees_cleaning: ['Cleaning'],
    fees_document: ['Unit Rate'],
    fees_trucking: ['Trucking Fees'],
    fees_special_storage: ['Lift Off', 'Lift On', 'Seal', 'Svc Chg'],
    currency: ['IDR', 'USD', 'SGD', 'HKD'],
    customer_select: {
      code: '',
      name: '',
    },
    form_cont_type: {
      type: '',
      description: '',
    },
    form_cont_cleaning: {
      code: '',
      description: '',
    },
    cust_payment_type: [],
    form_storage: {
      size: '20',
      type: 'GP',
      currency: 'IDR',
      nominal: '',
    },
    detail_price: false,
    form_default_price: {
      id_payment_type: '',
      cust_group: '',
      payment_type: '',
      currency: '',
      do_type: '',
      custom_field: '',
      costs: [
        {
          size: '',
          type: '',
          debet: '',
          kredit: '',
        },
      ],
    },
    lolo_storage: {},
    cleaning_fees: {},
    document_fees: {},
    special_fees: {},
    trucking_fees: {},
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: true,
    fields_principle: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'storage_free',
        label: 'Free Day',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_cleaning: [
      {
        key: 'cust_group',
        label: 'Group',
        sortable: true,
      },
      {
        key: 'do_type',
        label: 'DO Type',
        sortable: true,
      },
      {
        key: 'custom_field',
        label: 'Cleaning Type',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Payment',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_lolo: [
      {
        key: 'cust_group',
        label: 'Group',
        sortable: true,
      },
      {
        key: 'do_type',
        label: 'DO Type',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Payment',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_document: [
      {
        key: 'cust_group',
        label: 'Group',
        sortable: true,
      },
      {
        key: 'do_type',
        label: 'DO Type',
        sortable: true,
      },
      {
        key: 'custom_field',
        label: 'Type Payment',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Payment',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_storage: [
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'nominal',
        label: 'Nominal',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_vendor_price: [
      {
        key: 'cust_group',
        label: 'Group',
        sortable: true,
      },
      {
        key: 'do_type',
        label: 'DO Type',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_seal: [
      {
        key: 'cust_group',
        label: 'Group',
        sortable: true,
      },
      {
        key: 'do_type',
        label: 'DO Type',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Payment',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    vendor_truck_price: {
      id_principle: '',
      cust_group: '',
      id_vendortruck: '',
      vendor_code: '',
      vendor_name: '',
      do_type: '',
      currency: '',
      costs: [
        {
          size: '',
          type: '',
          tujuan: '',
          harga_vendor: '',
          harga_jual: '',
        },
      ],
    },
  },
};

export const mutations = {
  changeCustPrice(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetFormPrice(state) {
    state.data = Object.assign({}, state.data, {
      form_default_price: {
        id_payment_type: '',
        cust_group: '',
        payment_type: '',
        currency: '',
        do_type: '',
        custom_field: '',
        costs: [
          {
            size: '',
            type: '',
            debet: '',
            kredit: '',
          },
        ],
      },
    });
  },
  resetStorage(state) {
    state.data = Object.assign({}, state.data, {
      form_storage: {
        size: '20',
        type: 'GP',
        currency: 'IDR',
        nominal: '',
      },
    });
  },
};

export const getters = {
  form_storage(state) {
    return state.data.form_storage;
  },
  form_default_price(state) {
    return state.data.form_default_price;
  },
  type_payment(state) {
    return state.data.type_payment;
  },
  lolo_storage(state) {
    return state.data.lolo_storage;
  },
  cleaning_fees(state) {
    return state.data.cleaning_fees;
  },
  document_fees(state) {
    return state.data.document_fees;
  },
  trucking_fees(state) {
    return state.data.trucking_fees;
  },
  special_fees(state) {
    return state.data.special_fees;
  },
  vendor_truck_price(state) {
    return state.data.vendor_truck_price;
  },
};

export const actions = {
  async getPrinciplePaymentType({ commit, state }, payload = null) {
    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiGetRequest(
      `opr/principles/${payload ? payload.id : id_principle}/paidtype`
    );
    if (!result.error) {
      commit('changeCustPrice', {
        cust_payment_type: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getPrinciplePrice({ commit }, params = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    let result = await ApiGetRequest(`conf/principle-price`, params);
    if (!result.error) {
      if (result.data && result.data.object.length > 0) {
        commit('changeCustPrice', {
          ...result.data.object[0],
          loading: false,
        });
      } else {
        commit('changeCustPrice', {
          id: false,
          loading: false,
        });
      }
    }

    return !result.error ? true : false;
  },

  async getPrincipleType({ commit, state }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiGetRequest(
      `opr/principles/${payload ? payload.id_principle : id_principle}/type`
    );
    if (!result.error) {
      if (result.data && result.data.object.length > 0) {
        commit('changeCustPrice', {
          cont_type: result.data.object,
          loading: false,
        });
      } else {
        commit('changeCustPrice', {
          cont_type: [],
          loading: false,
        });
      }
    }

    return !result.error ? result.data.object : false;
  },

  async getPrincipleCleaning({ commit, state }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiGetRequest(
      `opr/principles/${payload ? payload.id_principle : id_principle}/cleaning`
    );
    if (!result.error) {
      if (result.data && result.data.object.length > 0) {
        commit('changeCustPrice', {
          cont_cleaning: result.data.object,
          loading: false,
        });
      } else {
        commit('changeCustPrice', {
          cont_cleaning: [],
          loading: false,
        });
      }
    }

    return !result.error ? result.data.object : false;
  },

  async createPrincipleType({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPostRequest(
      `opr/principles/${id_principle}/type`,
      payload.form
    );

    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCustPrice', {
        form_cont_type: {
          type: '',
          description: '',
        },
      });

      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePrincipleType({ commit, dispatch }, params) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiDeleteRequest(
      `opr/principles/${id_principle}/type/${params.id || ''}`
    );
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPrincipleCleaning({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPostRequest(
      `opr/principles/${id_principle}/cleaning`,
      payload.form
    );
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCustPrice', {
        form_cont_cleaning: {
          code: '',
          description: '',
        },
      });

      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePrincipleCleaning({ commit, dispatch }, params) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiDeleteRequest(
      `opr/principles/${id_principle}/cleaning/${params.id || ''}`
    );
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePrinciplePaidType({ commit, state }) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPutRequest(
      `opr/principles/${id_principle}/paidtype`,
      {
        paid_type: state.data.cust_payment_type,
      }
    );

    return result.error ? false : true;
  },

  async updatePrinciple({ commit }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/principles/${payload.id}`,
      payload.form
    );

    return result.error ? false : true;
  },

  async getListPrinciple({ commit, state }) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      is_price: 1,
    };

    let result = await ApiGetRequest(`opr/principles`, params);
    commit('changeCustPrice', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListPrinciplePrice({ commit, state }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      type: payload
        ? payload.type
        : data.tab_name[`tab_${data.tab_active}`] || '',
    };

    let result = await ApiGetRequest(
      `opr/principles/${id_principle}/price`,
      params
    );

    commit('changeCustPrice', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return result.error ? false : result.data.object;
  },

  async createDefaultPrice({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let data_document = data.cust_payment_type.filter((item) => {
      if (item.payment_type && item.payment_type.name === payload.name) {
        return item;
      }
    });

    let result = false;
    if (data_document.length > 0) {
      let id_payment_type = data_document[0].id_payment_type;
      result = await ApiPostRequest(`opr/principles/${id_principle}/price`, {
        ...payload.form,
        id_payment_type: id_payment_type,
      });

      if (!result.error) {
        showNotif(dispatch, {
          message: result.data.message,
          type: 'success',
        });
      }

      return result.error ? false : true;
    } else {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return false;
    }
  },

  async editDefaultPrice({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let data_document = data.cust_payment_type.filter((item) => {
      if (item.payment_type && item.payment_type.name === payload.name) {
        return item;
      }
    });

    let result = false;
    if (data_document.length > 0) {
      let id_payment_type = data_document[0].id_payment_type;
      result = await ApiPutRequest(
        `opr/principles/${id_principle}/price/${payload.id}`,
        {
          ...payload.form,
          id_payment_type: id_payment_type,
        }
      );

      if (!result.error) {
        showNotif(dispatch, {
          message: result.data.message,
          type: 'success',
        });
      }

      return result.error ? false : true;
    } else {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return false;
    }
  },

  async detailDefaultPrice({ commit, state }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiGetRequest(
      `opr/principles/${id_principle}/price/${payload.id}`
    );

    if (!result.error) {
      commit('changeCustPrice', {
        loading: false,
        form_default_price: {
          ...result.data.object,
          costs: result.data.object.principle_price_detail,
        },
      });
    }

    return result.error ? false : true;
  },

  async deleteDefaultPrice({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiDeleteRequest(
      `opr/principles/${id_principle}/price/${payload.id}`
    );

    if (!result.error) {
      commit('changeCustPrice', {
        loading: false,
      });

      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getListStorage({ commit, state }) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(
      `opr/principles/${id_principle}/storage`,
      params
    );

    commit('changeCustPrice', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getDetailStorage({ commit }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiGetRequest(
      `opr/principles/${id_principle}/storage/${payload.id}`
    );

    if (!result.error) {
      commit('changeCustPrice', {
        loading: false,
        form_storage: {
          ...result.data.object,
        },
      });
    } else {
      commit('changeCustPrice', {
        loading: false,
      });

      commit('resetFormPrice', {});
    }

    return result.error ? false : true;
  },

  async createStorage({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPostRequest(
      `opr/principles/${id_principle}/storage`,
      payload.form
    );

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async editStorage({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPutRequest(
      `opr/principles/${id_principle}/storage/${payload.id}`,
      payload.form
    );

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteStorage({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiDeleteRequest(
      `opr/principles/${id_principle}/storage/${payload.id}`
    );

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteUser({ commit, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`conf/principle-price/${payload.id}`);
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async searchVendorTrucking(context, payload = null) {
    let result = await ApiGetRequest(`opr/vendor-truck`, payload);
    return result.error ? [] : result.data.object;
  },

  async getVendorTruckPrice({ commit, state }) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/vendor-truck-price`, params);

    commit('changeCustPrice', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return result.error ? false : result.data.object;
  },

  async detailVendorTruckPrice({ commit, state }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/vendor-truck-price/${payload.id}`);
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCustPrice', {
        vendor_truck_price: {
          ...data.vendor_truck_price,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : result.data.object;
  },

  async createVendorTruckPrice({ commit, state, dispatch }) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    data.vendor_truck_price.id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPostRequest(
      `opr/vendor-truck-price`,
      data.vendor_truck_price
    );
    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updateVendorTruckPrice({ commit, state, dispatch }, payload = null) {
    commit('changeCustPrice', {
      loading: true,
    });

    const { data } = state;
    data.vendor_truck_price.id_principle = data.customer_select
      ? data.customer_select.id_principle
      : '';

    let result = await ApiPutRequest(
      `opr/vendor-truck-price/${payload.id}`,
      data.vendor_truck_price
    );

    commit('changeCustPrice', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
